<div [ngClass]="{'table-header-no-expandable-lines': !expandableLines}" class="table-header table-row">

  @if (expandableLines) {
    <div class="table-expand-button"></div>
  }

  <div [ngStyle]="columnStyles"
    class="table-header-entries"
    data-cy='table-header-entries'>

    @for (header of headers.entries | keyvalue: originalOrder; track header) {
      <div
        [ngClass]="{'no-expandable-lines': !expandableLines}"
        class="table-header-entry {{header.value.code}}"
        [ngStyle]="{'display': showColumn(header.key) ? 'inherit' : 'none'}"
        data-cy="table-header-entry">
        <!-- Header title section -->
        <span class="table-header-entry-content"
          [ngClass]="{'table-header-entry-content-not-sortable': !header.value.sortable}">
          <app-tooltip [message]="header.value.name">
            <span (click)="sortByStatusChange(header.value)"
              [attr.data-cy]="getDataCyHeaderColumnName(header.value.code)"
            [ngClass]="{'table-header-entry-name': header.value.sortable}">{{header.value.name}}</span>
          </app-tooltip>
          <!-- Sorting arrow section -->
          <div (click)="sortByStatusChange(header.value)"
            [attr.data-cy]="getDataCySortingArrowButton(header.value.code)"
            [ngClass]="{'hidden': !showSortingArrow(header.value)}"
            class="table-header-entry-sort-button">
            @if (showSortingArrow(header.value)) {
              <app-tooltip [dynamic]="false"
                message="Sort">
                            <span [attr.data-cy]="getDataCySortingArrow(header.value.code)" [ngClass]="{
                                'iwp-icon-gen_arrow_down': state.sortedBy.direction === sortDirection.DESC,
                                'iwp-icon-gen_arrow_up': state.sortedBy.direction === sortDirection.ASC
                            }"></span>
              </app-tooltip>
            }
          </div>
          <!-- Filter section -->
          <div class="table-header-entry-filter">
            @if (header.value.filterType != null) {
              <ng-container *ngTemplateOutlet="header.value.filterType"></ng-container>
            }
          </div>
        </span>
        <div class="table-header-entry-separator"></div>
      </div>
    }
  </div>
  <div class="table-context-menu"></div>
</div>
